import styled from 'styled-components';

export const AppContainer = styled.div`
  width: 100%;
  // overflow-y: auto;
  overflow-x: auto;
  // overflow-y: hidden;
  // background-color: #f4f4f9;
  background-color: #fff;
  // font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-family: 'Nunito', sans-serif;
  font-weight: 550; /* Adjust the weight as needed */
  // font-weight: bold;

  // h1 {
  //   font-size: 2rem;
  //   font-weight: 600;
  //   margin-bottom: 20px;
  //   color: #333;
  // }

  .popup-helper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9998 !important;
    pointer-events: none;
  }

  // .listings {
  //   width: 30%;
  //   margin-left: 70.5%;
  //   position: relative;
  //   z-index: 3;
  //   background-color: #fff;
  //   border-radius: 6px;
  //   box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  //   overflow: hidden;
  //   transition: transform 0.3s ease-in-out;
  // }


  // hide google map error
  // This page can't load Google Maps correctly.

// div[style*="background-color: white"][style*="position: absolute"][style*="z-index: 1"] {
//   display: none !important;
// }
div[style*="background-color: white"][style*="position: absolute"][style*="z-index: 1"][style*="max-width: 375px"][style*="transform: translateX(-50%)"][style*="width: calc(100% - 10px)"] {
  display: none !important;
}

  .slick-prev {
  left: -10px; /* Position the left arrow to the left */
  pointer-events: auto;
  }

  /* Style for the right arrow */
  .slick-next {
    right: -10px; /* Position the right arrow to the right */
    pointer-events: auto;
  }
.userList {
  pointer-events: none;
  position: absolute; /* Make sure it's positioned relative to AppContainer */
  top: 2%;
  left: 2%;
  color: red;
  margin: 0;
  padding: 5px;
  z-index: 1 !important ; /* Ensure userList is on top */

  // position: fixed;
  // top: 0;
  // left: 0;
  // bottom: 0;
  right: 63%; /* Change from 30% to 0 to make it full width */
  // z-index: 2;
  border-radius: 0; /* Optional: remove border-radius for a full screen effect */
  // overflow: hidden;

}



.listings {
  position: fixed; /* Use fixed positioning to position it relative to the screen */
  top: 0; /* Align it to the top of the screen */
  right: 0; /* Align it to the right side of the screen */
  width: 30%; /* Set the width to 30% */
  height: 100%; /* Make it take the full height of the screen */
  z-index: 3; /* Ensure it's on top of other elements */
  // background-color: rgba(0, 0, 0, 0); /* Transparent background */
  background-color: #fefefe; /* f5f5f5 Light pearl color */

  border-radius: 6px; /* Rounded corners */
  // box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
  // overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: auto;

  transition: transform 0.3s ease-in-out; /* Smooth transition for transform property */
}


.cards {
  max-width: 100%;
}

.cards-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center; /* Center cards horizontally */
  // gap: 10px; /* Reduced the gap between cards */
  // padding: 10px;
      gap: 7px;
    padding: 7px;
  box-sizing: border-box;
  // background-color: #fff;
  // background-color: rgba(100, 100, 100, .35);
  // background-color: #F5F5F5; /* Light pearl color */
  background-color: #fefefe; /* Light pearl color */


  &.is-empty {
    background-color: #eaeaea;
  }
}

.card {
  width: calc(33.333% - 8px); /* Fixed width for cards */
  flex-basis: calc(33.333% - 8px); /* flex-basis to maintain layout */
  flex-grow: 0; /* Prevent cards from growing */
  border-radius: 5px;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
      // box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);

  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  // background-color: #fff;
  // background-color: rgba(255, 255, 255, 0.9);
  background-color: #fefefe; /* Light pearl color */

  overflow: hidden;
  margin-bottom: 0px; /* Reduce bottom margin for less space between rows */

  &:hover {
    // transform: translateY(-8px);
    // box-shadow: 0 12px 24px rgba(0, 0, 0, 0.7);
  }

  .index {
    // background-color: rgba(0, 0, 0, 0.3);
    background-color: #fefefe; /* Light pearl color */

    color: #fefefe;
    padding: 8px 15px;
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 14px;
    border-radius: 20px;
  }

  .price {
    margin: 10px 0;
    padding: 8px 0;
    font-weight: 600;
    color: #0077ff;
  }

  .details {
    padding: 10px;
  }

  .features {
    list-style: none;
    display: flex;
    gap: 16px;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;

    li {
      display: flex;
      align-items: center;
      padding-left: 25px;
      margin-right: 10px;
      font-size: 14px;
      color: #666;

      span {
        display: none;
      }

      &.icon-bed {
        background: url(assets/images/bed-left-side.svg) no-repeat;
        background-size: contain;
      }
      &.icon-bath {
        background: url(assets/images/bathtub.svg) no-repeat;
        background-size: contain;
      }
      &.icon-car {
        background: url(assets/images/car-compact.svg) no-repeat;
        background-size: contain;
      }
    }
  }

  &.is-active {
    border-color: #1078ff;
    .index {
      background-color: #1078ff;
    }
  }
}

  .warning {
    font-size: 2rem;
    text-align: center;
    margin-top: 15%;
    color: #444;
    img {
      max-width: 80px;
      margin-bottom: 20px;
    }
  }

  .credits {
    text-align: center;
    padding: 40px;
    opacity: 0.7;
    transition: opacity 0.3s ease;
    &:hover {
      opacity: 1;
    }
    a {
      color: #4b4668;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
        color: #1078ff;
      }
    }
  }

  // .mapContainer {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   bottom: 0;
  //   right: 30%;
  //   z-index: 2;
  //   border-radius: 6px;
  //   overflow: hidden;
  // }

  // #map {
  //   width: 100%;
  //   height: 100%;
  //   background-color: rgba(173, 216, 230, 0.4);
  // }



.mapContainer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0%; /* Change from 30% to 0 to make it full width */
  z-index: 2;
  border-radius: 0; /* Optional: remove border-radius for a full screen effect */
  overflow: hidden;
}

#map {
  width: 100%;
  height: 100%;
  // background-color: rgba(173, 216, 230, 0.4);
  background-color: #fefefe; /* Light pearl color */

}

  .pin {
    cursor: pointer;
    transition: transform 0.2s ease;
    &:hover {
      transform: scale(1.2);
    }
  }

  header {
    display: flex;
    text-align: center;
    flex-direction: row;
    padding: 5px 15px;
    position: relative;
    // position: fixed;
    // background-color:  #e0e0e0;
    // background-color: rgba(255, 255, 255, 0.8);
    background-color: #fefefe; /* Light pearl color */

    // border-radius: 6px;
    z-index: 2;
    // box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);  /* Light shadow */
    // box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);

    height: 4dvh;


    img {
      max-width: 40px;
      margin-bottom: 10px;
    }

    h1 {
      font-size: 18px;
      text-transform: uppercase;
      color: #fefefe;
      margin-bottom: 10px;
    }

    .btn-clear {
      background: transparent;
      border: none;
      text-decoration: underline;
      color: #1078ff;
      font-weight: 600;
      transition: color 0.2s;

      &:hover,
      &:active {
        text-decoration: none;
        color: #004d7f;
      }
  }

// horizontal is ok but the img does not fill the container
// header {
//   text-align: center;
//   display: flex;
//   flex-direction: row;  /* Change to row for horizontal alignment */
//   align-items: center;  /* Align items vertically in the center */
//   justify-content: space-between;  /* Space out items horizontally */
//   padding: 20px 30px;
//   position: relative;
//   border-radius: 6px;
//   z-index: 2;
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1); /* Light shadow */

//   img {
//     max-width: 40px;
//     margin-bottom: 0;  /* Remove margin to keep aligned horizontally */
//     margin-right: 10px;  /* Add right margin to space out from h1 */
//   }

//   h1 {
//     font-size: 18px;
//     text-transform: uppercase;
//     color: #fff;
//     margin-bottom: 0;  /* Remove bottom margin */
//     margin-right: 20px;  /* Space out from the next elements */
//   }

//   .btn-clear {
//     background: transparent;
//     border: none;
//     text-decoration: underline;
//     color: #1078ff;
//     font-weight: 600;
//     transition: color 0.2s;

//     &:hover,
//     &:active {
//       text-decoration: none;
//       color: #004d7f;
//     }
//   }
// }


    @media (min-width: 992px) {
      h1 {
        font-size: 20px;
      }
      img {
        max-width: 70px;
      }
    }
  }

.user-status {
  display: flex; /* Flexbox for easy alignment */
  // flex-direction: column; /* Stack the elements vertically */
    flex-direction: row; /* Align the elements horizontally */

  align-items: flex-start; /* Align the items to the start (left) */
  padding: 20px; /* Add some space around the text */
  width: 100%; /* Ensure it takes the full width of its container */
  box-sizing: border-box; /* Ensure padding doesn't overflow the container */
}

.user-status span {
  white-space: normal; /* Allow text to wrap */
  word-wrap: break-word; /* Ensure long words break and wrap to the next line */
}

@media (max-width: 768px) {
  /* Header positioning for small screens */

.userList {
  position: absolute; /* Make sure it's positioned relative to AppContainer */
  top: 0; //0.5dvh;
  // top: 10%;
  color: red;
  margin: 0;
  padding: 0px;
  z-index: 999999 !important; /* Ensure userList is on top */
  pointer-events: auto;

  // position: fixed;
  // top: 0;
  // left: 0;
  // bottom: 0;
  right: 0; /* Change from 30% to 0 to make it full width */
  left: 0;

  // z-index: 2;
  border-radius: 0; /* Optional: remove border-radius for a full screen effect */
  // overflow: hidden;
  // border-bottom: 1px solid #e0e0e0;
  // height: 10dvh;

}


  // header {
  //   position: fixed;
  //   // top: 0; -> in Header.css .app-header
  //   left: 0;
  //   width: 100%;
  //   height: 16dvh; /* Adjust height of the header */

  //   background-color: rgba(255, 255, 255, 0.75); /* Semi-transparent background */
  //   // background: radial-gradient(
  //   //   circle at center,
  //   //   rgba(255, 255, 255, 0.75) 0%,
  //   //   rgba(255, 255, 255, 0.5) 60%,
  //   //   rgba(255, 255, 255, 0.3) 100%
  //   // );    
  //   // background: radial-gradient(
  //   //   ellipse 60% 40% at center,
  //   //   rgba(255, 255, 255, 0.75) 0%,    /* light greenish white center */
  //   //   rgba(255, 255, 255, 0.5) 60%,    /* mid green tint */
  //   //   rgba(255, 255, 255, 0.3) 100%    /* faint green edges */
  //   // );


  //   backdrop-filter: blur(24px);
  //   -webkit-backdrop-filter: blur(24px);

  // // box-shadow: 0px -4px 30px rgba(0, 255, 200, 1); /* adds bloom from below */

  // // background: rgba(255, 255, 255, 0.65);  /* very translucent white */
  // // backdrop-filter: blur(20px);           /* heavy blur like Safari */
  // // -webkit-backdrop-filter: blur(20px);   /* Safari support */
  // // border-bottom: 1px solid rgba(255, 255, 255, 0.2); /* subtle border */


  //   // background-color: #fefefe; /* Light pearl color */

  //   z-index: 10001; //9999; /* Ensure it's above other elements */
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   padding: 10px;
  //   // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Light shadow for depth */
  //   // box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
  //   // border-bottom: 1px solid #e0e0e0;
  //   box-shadow: 0 0px 2px rgba(0, 0, 0, 0.1);


  // }

header {
  position: fixed;
  left: 0;
  width: 100%;
  height: 6dvh; /* Adjust height of the header */
  // z-index: 10001;
  z-index: 10002;


  /* Frosted glass base */
  background-color: rgba(255, 255, 255, 1);
  // background-color: rgba(254, 254, 254, 1);
  // background-color: rgba(245, 250, 255, 0.65); /* Slight cool tint */
  // background-color: rgba(230, 245, 255, 0.65);//	Trắng hơi xanh, trong như băng
  // background-color: rgba(200, 230, 255, 0.6);	//Xanh băng đậm hơn, nổi bật hơn -> ok on iphone (yellower than the above), yet transparent not frosty on android ?? FIXED: forgot to comment the text, iphone works but android throw prob
  // background-color: rgba(190, 240, 255, 0.1);	// Màu pha cho hiệu ứng kính mờ -> not bad on white background but a little distracting
  // background-color: rgba(230, 249, 255, 0.65); /* same as #e6f9ff (	Màu xanh băng Bắc Cực nhẹ) with transparency */ -> kind of blueish


  // backdrop-filter: blur(24px) saturate(160%) brightness(1.15);
  // -webkit-backdrop-filter: blur(24px) saturate(160%) brightness(1.15);
  // backdrop-filter: blur(24px) saturate(75%) brightness(1.27);
  // -webkit-backdrop-filter: blur(24px) saturate(75%) brightness(1.27);



// best transparent, frosty bg
  // // combination 1 good -> looks underwhelm by the frosty login modal
  // background-color: rgba(245, 245, 245, 0.75); //	Trắng lạnh, dùng cho nền glass -> look likes safari
  // background-color: rgba(255, 255, 255, 0.91); //	Trắng lạnh, dùng cho nền glass -> look likes safari
  // backdrop-filter: blur(30px) saturate(120%) brightness(1.2);
  // -webkit-backdrop-filter: blur(30px) saturate(120%) brightness(1.2);

  // // combination 2 good ->> on parse with login modal
  // background-color: rgba(255, 255, 255, 0.75); 
  // backdrop-filter: blur(30px) saturate(120%) brightness(1.2);
  // -webkit-backdrop-filter: blur(30px) saturate(120%) brightness(1.2);
  // box-shadow: 0 0 4px rgba(0, 0, 0, 0.2); /* Soft greenish glow upward */

  // combination 3 solid white -> comback to solid white
  // background-color: rgba(255, 255, 255, 1); 
  // backdrop-filter: blur(30px) saturate(120%) brightness(1.2);
  // -webkit-backdrop-filter: blur(30px) saturate(120%) brightness(1.2);
  // box-shadow: 0 0 4px rgba(0, 0, 0, 0.2); /* Soft greenish glow upward */


  // // combination 0 -> blueish on a white backround, not for this map app
  // background-color: rgba(240, 250, 255, 0.75); //	Trắng lạnh, dùng cho nền glass -> look likes safari
  // backdrop-filter: blur(30px) saturate(120%) brightness(1.1);
  // -webkit-backdrop-filter: blur(30px) saturate(120%) brightness(1.1);



  /* Subtle glow coming from behind */
  // box-shadow: 0 0 6px rgba(0, 255, 200, 0.5); /* Soft greenish glow upward */

  /* Optional radial light bloom inside the header */
  // background-image: radial-gradient(
  //   ellipse 80% 60% at center,
  //   rgba(255, 255, 255, 0.35),
  //   rgba(0, 255, 200, 0.08),
  //   rgba(255, 255, 255, 0.05)
  // );

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;

  // border-top: 1px solid rgba(0, 0, 0, 0.5); /* thin shadow line */
  border-top: 1px solid rgba(224, 224, 224, 0.333)
}

  
  /* Adjust the mapContainer to avoid overlap with the header */
  .mapContainer {
    position: fixed;
    top: 0; /* Offset by the header height */
    left: 0;
    right: 0;
    bottom: 0; /* Take full height below the header */
    z-index: 2;
    overflow: hidden;
  }

  #map {
    width: 100%;
    height: 100%;
    // background-color: rgba(173, 216, 230, 0.4); /* Optional background color for map */
    background-color: #fefefe; /* Light pearl color */

  }

  /* Adjust listings positioning on small screens */
  .listings {
    position: fixed;
    top: auto;
    // /* Start listings slightly below the header */
    bottom: 0%;
    right: 0;
    width: 100%;
    height: calc(100vh - 8vh); /* Adjust to take up remaining space below the header */
    z-index: 3;
    // background-color: rgba(0, 0, 0, .7); /* Optional background color */
    // background-color: #F5F5F5; /* Light pearl color */
    background-color: #fefefe; /* Light pearl color */


    // box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); /* Shadow for depth */
    // overflow-y: auto; /* Ensure scrolling is enabled */
    overflow-x: auto; /* Ensure scrolling is enabled */
    padding-bottom: 10px; /* Optional: add padding to bottom for better spacing */

    /* Rounded top corners */
    border-top-left-radius: 20px;  /* Adjust the radius as needed */
    border-top-right-radius: 20px; /* Adjust the radius as needed */

  }

  .cards-list {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
    padding: 0px;
    // border-radius: 50px;
    // background-color: rgba(255, 255, 255, 0.7);
    background-color: #fefefe; /* Light pearl color */

    box-sizing: border-box;
    margin-top: 4px; 
    // margin-top: 4400px; 
    /* Adjust the value as needed */
    // border-radius: 0px;
    // top: 20%;
  }

  .cards-list2 {
    display: flex;
    flex-wrap: wrap;
    // gap: 1.1px;
    gap: 2px;
    padding: 0px;
    // border-radius: 50px;
    // background-color: rgba(255, 255, 255, 0.7);
    background-color: #fefefe; /* Light pearl color */

    box-sizing: border-box;
    // margin-top: 4px; 
    // margin-top: 4400px; 
    // margin-top: 1305%;     
    /* Adjust the value as needed */
    // border-radius: 0px;
    // top: 23000% !important;
    // top: 30%;
    // margin-right: -1%;
    margin-right: 1px;
    margin-left: 2px;
  }

  /* Masonry Layout Styles */
  .masonry-container {
    column-count: 2;
    column-gap: 8px;
    padding: 0 8px;
  }

  .masonry-item {
    break-inside: avoid;
    margin-bottom: 16px;
  }

  /* Hide scrollbar for cleaner masonry layout */
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .card {
     scrollbar-width: thin;
    //flex: 1 1 calc(33.333% - 10px); /* 3 cards per row with gap considered */
    width: calc(33.333% - 2px); /* Fixed width for cards */
    flex-basis: calc(33.333% - 2px); /* flex-basis to maintain layout */
    flex-grow: 0; /* Prevent cards from growing */
    // background-color: rgba(255, 255, 255, 0.7);
    background-color: #fefefe; /* Light pearl color */

    border-radius: 0px; // 5px;
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    // box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);

    transition: all 0.3s ease;
    // aspect-ratio: 1 / 1;
    aspect-ratio: 9 / 13;

  }

    /* Make the filter visible on mobile */
    .filter {
      position: fixed;
      top: 10vh; /* Ensure the filter appears below the header */
      right: 0;
      width: 100%;
      height: auto;
      background-color: #fefefe;
      z-index: 3;
      // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      padding: 10px;
      transition: transform 0.3s ease-in-out;
      display: none;
    }

    /* Make sure listings are not hidden under the map */
    .filter-is-visible .filter {
      transform: translateY(0);
    }
  }

  /* PC Screen Styles */
  @media (min-width: 768px) {
  .listings,
    .cards-list2 { /* Apply styles to cards-list2 as well */
      width: 28%; /* Slightly narrower sidebar for more map space */
      right: 0;
      top: 0;
      height: 100%;
      background-color: #fefefe; /* Light pearl color */
      border-radius: 0; /* Remove border radius for full height sidebar */
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
      overflow-y: auto; /* Enable vertical scrolling */
    }

    .mapContainer {
      right: 72%; /* Adjust map width to match narrower sidebar */
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      border-radius: 0; /* Remove border radius for full height map */
      overflow: hidden;
    }

    #map {
      width: 100%;
      height: 100%;
      background-color: #fefefe; /* Light pearl color */
    }

    header {
      position: relative; /* Reset position for PC layout */
      height: 6dvh; /* Adjust height for PC header */
      padding: 5px 15px;
      background-color: #fefefe; /* Light pearl color */
      z-index: 2;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.5); /* Light shadow */
    }

    .cards-list,
    .cards-list2 { /* Apply flex properties to cards-list2 */
      display: flex; /* Ensure flex properties are set */
      flex-wrap: wrap; /* Allow items to wrap to the next line */
      justify-content: center; /* Center items horizontally */
      gap: 10px; /* Increased gap for PC */
      padding: 10px;
    }

    .card, .cards-list2 {
      // width: calc((100% - 30px) / 3); 
      /* Increase gap between cards for better layout */
      width: 100vw;
      flex-basis: calc((100% - 20px) / 3);
      flex-grow: 1; /* Allow cards to grow to fill space */
      border-radius: 5px; /* Restore border radius for PC cards */
      background-color: #fefefe; /* Light pearl color */
    }

    .filter {
      position: static; /* Make filter static for PC */
      width: auto;
      padding: 0;
      background-color: transparent;
      box-shadow: none;
      z-index: auto;
      display: block !important; /* Ensure filter is visible on PC */
      margin-top: 10px; /* Add some margin */
    }

    .filter-is-visible .filter {
      transform: none; /* Remove transform for PC */
    }

    .btn-filter {
      width: auto; /* Auto width for button on PC */
      margin-top: 0;
    }
  }

  /* PC Screen Styles */
  @media (min-width: 992px) {
    .listings {
      width: 30%; /* Sidebar width */
      right: 0;
      top: 0;
      height: 100%;
      background-color: #fefefe; /* Light pearl color */
      border-radius: 0; /* Remove border radius for full height sidebar */
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
      overflow-y: auto; /* Enable vertical scrolling */
    }

    .mapContainer {
      right: 30%; /* Make space for the sidebar */
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      border-radius: 0; /* Remove border radius for full height map */
      overflow: hidden;
    }

    #map {
      width: 100%;
      height: 100%;
      background-color: #fefefe; /* Light pearl color */
    }

    header {
      position: relative; /* Reset position for PC layout */
      height: 6dvh; /* Adjust height for PC header */
      padding: 5px 15px;
      background-color: #fefefe; /* Light pearl color */
      z-index: 2;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.5); /* Light shadow */
    }

    .cards-list {
      gap: 10px; /* Increased gap for PC */
      padding: 10px;
    }

    .card {
      width: calc(33.333% - 10px); /* Adjust card width for PC */
      flex-basis: calc(33.333% - 10px);
      border-radius: 5px; /* Restore border radius for PC cards */
      background-color: #fefefe; /* Light pearl color */
    }

    .filter {
      position: static; /* Make filter static for PC */
      width: auto;
      padding: 0;
      background-color: transparent;
      box-shadow: none;
      z-index: auto;
      display: block !important; /* Ensure filter is visible on PC */
      margin-top: 10px; /* Add some margin */
    }

    .filter-is-visible .filter {
      transform: none; /* Remove transform for PC */
    }

    .btn-filter {
      width: auto; /* Auto width for button on PC */
      margin-top: 0;
    }
  }

  /* PC Screen Styles */
  @media (min-width: 992px) {
    .listings {
      width: 30%; /* Sidebar width */
      right: 0;
      top: 0;
      height: 100%;
      background-color: #fefefe; /* Light pearl color */
      border-radius: 0; /* Remove border radius for full height sidebar */
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
      overflow-y: auto; /* Enable vertical scrolling */
    }

    .mapContainer {
      right: 30%; /* Make space for the sidebar */
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      border-radius: 0; /* Remove border radius for full height map */
      overflow: hidden;
    }

    #map {
      width: 100%;
      height: 100%;
      background-color: #fefefe; /* Light pearl color */
    }

    header {
      position: relative; /* Reset position for PC layout */
      height: 6dvh; /* Adjust height for PC header */
      padding: 5px 15px;
      background-color: #fefefe; /* Light pearl color */
      z-index: 2;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.5); /* Light shadow */
    }

    .cards-list {
      gap: 10px; /* Increased gap for PC */
      padding: 10px;
    }

    .card {
      width: calc(33.333% - 10px); /* Adjust card width for PC */
      flex-basis: calc(33.333% - 10px);
      border-radius: 5px; /* Restore border radius for PC cards */
      background-color: #fefefe; /* Light pearl color */
    }

    .filter {
      position: static; /* Make filter static for PC */
      width: auto;
      padding: 0;
      background-color: transparent;
      box-shadow: none;
      z-index: auto;
      display: block !important; /* Ensure filter is visible on PC */
      margin-top: 10px; /* Add some margin */
    }

    .filter-is-visible .filter {
      transform: none; /* Remove transform for PC */
    }

    .btn-filter {
      width: auto; /* Auto width for button on PC */
      margin-top: 0;
    }
  }


  .advanced-search-v3,
  .site-footer,
  #footer {
    display: none;
  }

  .btn-filter {
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 14px;
    background: #1078ff;
    color: #fefefe;
    border: none;
    transition: background 0.3s ease;
    width: 100%;
    margin-top: 20px;

    &:hover,
    &:active {
      background-color: #005bb5;
    }
  }

  .filter {
    // display: none !important;
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
    position: fixed;
    top: 0;
    right: 0;
    width: 50%;
    padding: 32px;
    background-color: #fefefe;
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 3;

    .filterBox {
      margin: 0 20px 20px 0;
      display: inline-block;

      label {
        display: block;
        font-weight: 500;
        color: #444;
        margin-bottom: 8px;
      }

      input,
      select {
        width: 100%;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #ccc;
        margin-top: 5px;
        font-size: 14px;
        transition: border-color 0.2s;

        &:focus {
          border-color: #1078ff;
        }
      }
    }

    .btn-filter {
      position: absolute;
      top: 20px;
      right: 20px;
      background-color: #1078ff;
      color: #fefefe;

      &:hover,
      &:active {
        background-color: #005bb5;
      }
    }
  }

  .filter-is-visible .filter {
    // display: none !important;
    transform: translateY(0%);
  }
  
  /* Hide scrollbar for header tabs */
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;
